import { useMemo } from 'react';
import { useIsDemo } from '@/hooks/common/useIsDemo';
import {
  demoProfilePictures,
  demoUserDisplayInfo,
  DEMO_USER_IDS,
} from '@/mockData/demoContractData';

export function useDemoUsers() {
  const isDemo = useIsDemo();

  const profilePictures = useMemo(
    () => (isDemo ? demoProfilePictures : ({} as typeof demoProfilePictures)),
    [isDemo],
  );

  const userDisplayInfo = useMemo(
    () => (isDemo ? demoUserDisplayInfo : ({} as typeof demoUserDisplayInfo)),
    [isDemo],
  );

  const userIds = useMemo(
    () => (isDemo ? DEMO_USER_IDS : ({} as typeof DEMO_USER_IDS)),
    [isDemo],
  );

  return { profilePictures, userDisplayInfo, userIds };
}
